// Tema fácil de rebrandear. `accent` = único punto a tocar para dar identidad.
// Paleta inicial: verde cancha + dorado copa (clima mundialero).

export interface AppTheme {
  name: 'light' | 'dark';
  colors: {
    bg: string;
    surface: string;
    surfaceAlt: string;
    border: string;
    borderStrong: string;
    text: string;
    textMuted: string;
    accent: string;
    accentText: string;
    gold: string;
    live: string;
    danger: string;
  };
  radius: string;
  maxWidth: string;
}

const accent = '#0b6e4f'; // verde cancha
const gold = '#f4b324'; // dorado copa

export const dark: AppTheme = {
  name: 'dark',
  colors: {
    bg: '#0f1115',
    surface: '#181b21',
    surfaceAlt: '#21252e',
    border: '#2c313b',
    borderStrong: '#4a525f',
    text: '#f2f4f8',
    textMuted: '#9aa3b2',
    accent: '#13a06f',
    accentText: '#ffffff',
    gold,
    live: '#ff4d4f',
    danger: '#ff5252',
  },
  radius: '14px',
  maxWidth: '720px',
};

export const light: AppTheme = {
  name: 'light',
  colors: {
    bg: '#f4f5f7',
    surface: '#ffffff',
    surfaceAlt: '#eef0f3',
    border: '#dfe2e8',
    borderStrong: '#b3bac6',
    text: '#14161a',
    textMuted: '#5b6472',
    accent,
    accentText: '#ffffff',
    gold: '#c98a06',
    live: '#e0282e',
    danger: '#d32f2f',
  },
  radius: '14px',
  maxWidth: '720px',
};

export const themes = { dark, light };
